import useSWR from 'swr';

import { fetchEndpointData } from '@utils/fetchEndpointData';
import type { DriverAppStatsResponse } from './endpoints/DriverAppStatsEndpoint.types';
import type { OrderStatsResponse } from './endpoints/OrderStatsEndpoint.types';

export async function fetchDriverAppStats(params: {
  from: string;
  to: string;
  supplierId?: number;
  licensePlate?: string;
  businessUnit?: string;
}): Promise<DriverAppStatsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('from', params.from);
  searchParams.set('to', params.to);
  if (params.supplierId !== undefined) {
    searchParams.set('supplierId', params.supplierId.toString());
  }
  if (params.licensePlate) {
    searchParams.set('licensePlate', params.licensePlate);
  }
  if (params.businessUnit) {
    searchParams.set('businessUnit', params.businessUnit);
  }
  return fetchEndpointData<DriverAppStatsResponse>(`/api/v1/stats/driver-app?${searchParams.toString()}`);
}

export interface OrderStatsFilters {
  startDate: string;
  endDate: string;
  /** GraphQL BusinessUnit enum name, e.g. "Benelux". */
  businessUnit?: string | null;
  dealOwnerId?: string | null;
}

export async function fetchOrderStats(filters: OrderStatsFilters): Promise<OrderStatsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('startDate', filters.startDate);
  searchParams.set('endDate', filters.endDate);
  if (filters.businessUnit) {
    searchParams.set('businessUnit', filters.businessUnit);
  }
  if (filters.dealOwnerId) {
    searchParams.set('dealOwnerId', filters.dealOwnerId);
  }
  return fetchEndpointData<OrderStatsResponse>(`/api/v1/stats/orders?${searchParams.toString()}`);
}

export function useOrderStats(filters: OrderStatsFilters) {
  return useSWR(['order-stats', filters.startDate, filters.endDate, filters.businessUnit, filters.dealOwnerId], () =>
    fetchOrderStats(filters),
  );
}
